import {Badge, Button, FormControlLabel, Grid2 as Grid, Switch, useTheme} from "@mui/material";
import {IndentSpace} from "../../../domains/common/components/Typography";
import {setUserOption, userOptions} from "../../../user";
import React, {useContext, useEffect, useState} from "react";
import {getDealsNumWaitingPayment} from "../dealsApi";
import {DealsPageContext} from "../index";

export const DealsFilter = () => {
  const [stateFilter, setStateFilter] = useState('');
  const [waitPaymentNum, setWaitPaymentNum] = useState(0);
  const {loadDealsData, loadListDataWStateFilter} = useContext(DealsPageContext);

  useEffect(() => {
    countWaitingPayment();

    const interval = setInterval(() => {
      countWaitingPayment();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, [])

  const setOnlyMyDeal = async () => {
    if (userOptions.onlyMyDeal === true)
      await setUserOption('onlyMyDeal', false);
    else
      await setUserOption('onlyMyDeal', true);

    setStateFilter('');

    countWaitingPayment();
    loadDealsData();
  }

  const handleStateFilter = async (val) => {
    if (stateFilter === val || val === 'all') {
      setStateFilter('');
      loadDealsData();
    } else {
      await loadListDataWStateFilter(val)
      setStateFilter(val);
    }
  }

  const countWaitingPayment = async () => {
    const result = await getDealsNumWaitingPayment();

    if (result?.ok && result?.data?.dealsWaitingPayment)
      setWaitPaymentNum(result.data?.dealsWaitingPayment)
  }

  const theme = useTheme();

  return (<Grid container spacing={0} sx={{}} wrap="nowrap">
    <Grid size={{xs: 0, sm: 0, md: 2.5, lg: 1.5}}/>
    <Grid size={8} sx={{
      lineHeight: '40px',
      paddingLeft: {xs: '10px', sm: '10px', md: '10px', lg: '0px'},
      minWidth: '500px'
    }}>
      {
        StateFilterButton({rendState: 'all', currentState: stateFilter || 'all', onClick: handleStateFilter})
      }
      <IndentSpace size={10}/>
      {
        StateFilterButton({rendState: 'draft', currentState: stateFilter, onClick: handleStateFilter})
      }
      <IndentSpace size={10}/>
      {
        StateFilterButton({rendState: 'documentsOnSign', currentState: stateFilter, onClick: handleStateFilter})
      }
      <IndentSpace size={10}/>
      {
        StateFilterButton({rendState: 'documentsSign', currentState: stateFilter, onClick: handleStateFilter})
      }
      <IndentSpace size={10}/>
      <Badge badgeContent={waitPaymentNum} color="error">
        {
          StateFilterButton({
            rendState: 'rosreestrQuitance',
            currentState: stateFilter,
            onClick: handleStateFilter
          })
        }
      </Badge>
      <IndentSpace size={10}/>
      {
        StateFilterButton({
          rendState: 'rosreestrValidationError',
          currentState: stateFilter,
          onClick: handleStateFilter
        })
      }
      <IndentSpace size={10}/>
      {
        StateFilterButton({rendState: 'dealSentToRR', currentState: stateFilter, onClick: handleStateFilter})
      }
      <IndentSpace size={10}/>
      {
        StateFilterButton({rendState: 'dealCompleted', currentState: stateFilter, onClick: handleStateFilter})
      }
      <IndentSpace size={10}/>
      {
        StateFilterButton({
          rendState: 'rosreestrInterrupted',
          currentState: stateFilter,
          onClick: handleStateFilter
        })
      }
    </Grid>
    <Grid size={1} sx={{lineHeight: '40px', whiteSpace: 'nowrap', minWidth: 'fit-content'}} display="flex"
          justifyContent="flex-end">
      <FormControlLabel
        control={
          <Switch checked={userOptions.onlyMyDeal} onClick={setOnlyMyDeal}/>
        }
        label="Мои сделки"
        labelPlacement="start"
        sx={{color: theme.palette.text.secondary}}
      />
    </Grid>
  </Grid>)
}

/**
 * Возвращает кнопку фильтра
 * Если состояние кнопки совпадает с текущим состоянием, то вернёт активную кнопку
 * @param rendState - какую кнопку надо отрисовать
 * @param currentState - текущее состояние в родительском компоненте
 * @param onClick
 * @return {Element}
 * @constructor
 */
function StateFilterButton({rendState, currentState, onClick}) {
  const theme = useTheme();

  const activeFilterBtn = {
    boxShadow: 0,
    borderRadius: '15px',
    fontSize: '12px',
    textTransform: 'none',
    fontWeight: 400,
    '&:hover': {
      boxShadow: 1,
    }
  };
  const unactiveFilterBtn = {
    boxShadow: 1,
    borderRadius: '15px',
    fontSize: '12px',
    textTransform: 'none',
    fontWeight: 400,
    color: theme.palette.button.text.secondary,
    background: theme.palette.button.background.secondary,
    '&:hover': {
      boxShadow: 1,
      background: theme.palette.button.background.hoverSecondary,
    }
  };

  const map = {
    'all': 'Все',
    'rosreestrQuitance': 'Ожидают оплаты',
    'draft': 'Черновики',
    'documentsOnSign': 'На подписании',
    'documentsSign': 'Подписанные',
    'dealCompleted': 'Завершенные',
    'rosreestrInterrupted': 'Отказ заявителя',
    'rosreestrValidationError': 'С ошибками',
    'dealSentToRR': 'На рассмотрении'
  }

  {
    return currentState === rendState ?
      <Button
        size="small"
        sx={activeFilterBtn}
        variant="contained"
        onClick={() => onClick ? onClick(rendState) : void 0}>
        {map[rendState]}
      </Button> :
      <Button
        size="small"
        sx={unactiveFilterBtn}
        variant="contained"
        onClick={() => onClick ? onClick(rendState) : void 0}>
        {map[rendState]}
      </Button>
  }
}